import { __currentUser__ } from "../../../graphql/policies";
import { MarketType } from "../types";

export default function getAuthorizedMarkets(): MarketType[] {
  const { afUserMarkets } = __currentUser__() || {};

  return afUserMarkets?.map((item) => item?.market as MarketType) ?? [];
}
